export const translatableFields: Record<string, string[]> = {
  'staff:staff_team_member': ['display_name', 'description'],
}

export default translatableFields
